import { useQuery } from '@tanstack/react-query';
import { getCompanyById } from '../services/companyService';

export function useCompany(id: string) {
  return useQuery({
    queryKey: ['company', id],
    queryFn: () => getCompanyById(id),
    enabled: !!id,
  });
}
